import { render } from "./OrderExpenseEditPage.vue?vue&type=template&id=0c820b38"
import script from "./OrderExpenseEditPage.vue?vue&type=script&lang=js"
export * from "./OrderExpenseEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__